import { MenuItem, Select } from "@mui/material";
import i18next from "i18next";
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from "react-hook-form";
import { DefaultSelectProps } from "../../services/common/Constants";

const AttributeUniqueSelectInput = ({ listItems, setSelectedAttribute = () => {}, save = () => {} }) => {
  const formMethods = useFormContext();

  const [isFocused, setIsFocused] = useState(true);

  useEffect(() => {
    if (!isFocused) {
      setSelectedAttribute(null);
      save();
    }
    // eslint-disable-next-line
  }, [isFocused]);

  return (
    <Controller
      control={formMethods.control}
      name="value"
      render={({ field }) => (
        <Select
          {...field}
          id="tp-attribute-select-id"
          variant="outlined"
          displayEmpty
          onChange={(event) =>
            formMethods.setValue("value", event.target.value)
          }
          autoFocus
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          MenuProps={DefaultSelectProps.MenuProps}
          sx={{
            border: "none",
            borderRadius: "0 12px 12px 0",
            fontSize: "14px",
            paddingRight: "16px",
            height: "100%"
          }}
        >
          <MenuItem key={"notSpecified"} value={null}>
            <em>{i18next.t("notSpecified")}</em>
          </MenuItem>
          {listItems?.map((item) => (
            <MenuItem key={item} value={item}>
              <span>{item}</span>
            </MenuItem>
          ))}
        </Select>
      )}
    />
  );
};
export default AttributeUniqueSelectInput;
